<template>

  <small
    v-if="error"
    class="text-danger validate-message">
    {{ error['message'] }}
  </small>

</template>

<script>
export default {
  name: 'ValidateMessage',
  props: [
    'error'
  ],
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/ValidateMessage.vue